class DealerDocumentDetailModel {
    dealerDocumentId: string;
    dealerDocumentConfigId: string;
    dealerId: string;
    docName: string;
    path: string;
    createdUserId: string;
    constructor(dealerDocumentDetailModel: DealerDocumentDetailModel) {
        this.dealerDocumentId =  dealerDocumentDetailModel?.dealerDocumentId ?  dealerDocumentDetailModel?.dealerDocumentId : '';
        this.dealerDocumentConfigId =  dealerDocumentDetailModel?.dealerDocumentConfigId ?  dealerDocumentDetailModel?.dealerDocumentConfigId : '';
        this.dealerId =  dealerDocumentDetailModel?.dealerId ?  dealerDocumentDetailModel?.dealerId : '';
        this.docName =  dealerDocumentDetailModel?.docName ?  dealerDocumentDetailModel?.docName : '';
        this.path =  dealerDocumentDetailModel?.path ?  dealerDocumentDetailModel?.path : '';
        this.createdUserId =  dealerDocumentDetailModel?.createdUserId ?  dealerDocumentDetailModel?.createdUserId : '';

    }
}

class DealerAvsDocumentDetailModel {
    dealerId: string;
    dealerBranchId: string;
    dealerPrincipleId: string;
    fileName: string;
    createdUserId: string;
    modifiedUserId: string;
    constructor(dealerAvsDocumentDetailModel: DealerAvsDocumentDetailModel) {
        this.dealerId =  dealerAvsDocumentDetailModel?.dealerId ?  dealerAvsDocumentDetailModel?.dealerId : '';
        this.dealerBranchId =  dealerAvsDocumentDetailModel?.dealerBranchId ?  dealerAvsDocumentDetailModel?.dealerBranchId : '';
        this.dealerPrincipleId =  dealerAvsDocumentDetailModel?.dealerPrincipleId ?  dealerAvsDocumentDetailModel?.dealerPrincipleId : '';
        this.fileName =  dealerAvsDocumentDetailModel?.fileName ?  dealerAvsDocumentDetailModel?.fileName : '';
        this.createdUserId =  dealerAvsDocumentDetailModel?.createdUserId ?  dealerAvsDocumentDetailModel?.createdUserId : '';
        this.modifiedUserId =  dealerAvsDocumentDetailModel?.modifiedUserId ?  dealerAvsDocumentDetailModel?.modifiedUserId : '';
    }
}


export { DealerDocumentDetailModel, DealerAvsDocumentDetailModel }
